module.exports = __webpack_public_path__ + "img/google07.29d82177.jpg";